var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CAppNav',{attrs:{"global-store":_vm.globalStore,"search-visible":_vm.searchVisible},on:{"close-search":_vm.handleSearchClose,"select-entry-view":_vm.selectEntryView,"show-account-menu":function($event){return _vm.$emit('show-account-menu')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }